import styled from 'styled-components';
import { Field, useField } from 'formik';
import * as Yup from 'yup';

import { FormRowsDivider, InputField } from '../../../fields';
import { Alert, Button, Typography } from '@mui/material';
import { SendTestLead } from '../../send-test-lead';

export const TelegramIntegration = () => {
  const [{ value: telegramIntegration }, { error }] = useField('campaign.telegramIntegration');
  const [{ value: campaignId }] = useField('campaign.id');

  const validate = (value: string, schema: Yup.AnySchema) => {
    try {
      schema.validateSync(value);
    } catch (error) {
      return (error as any).message;
    }
  };

  return (
    <>
      <FormRowsDivider />

      <Typography sx={{ fontWeight: 'bold', marginBottom: '12px' }}>Уведомления в Telegram</Typography>

      <Alert severity="info" variant="filled" sx={{ marginBottom: '24px' }}>
        Укажите все аккаунты, на которые хотите получать уведомления. <br /> Также, в каждом аккаунте Telegram
        необходимо начать диалог с нашим ботом. Для этого просто напишите ему любое сообщение
        <br />
        <Button
          href="https://t.me/popup_games_notifications_bot?start=hello"
          target="_blank"
          sx={{ marginLeft: '-8px', marginTop: '12px' }}
        >
          Начать диалог с ботом
        </Button>
      </Alert>

      <Row column>
        <Field
          name="campaign.telegramIntegration.usernames"
          component={InputField}
          label="Username"
          className="form-field webhook-input"
          validate={(value: string) => validate(value, Yup.string().nullable())}
          helperText="Введите никнейм (если их несколько, то через запятую)"
          placeholder="@username1, @username2"
        />

        {telegramIntegration?.usernames && !error && (
          <SendTestLead
            integrationId="telegram"
            campaignId={campaignId}
            params={{ usernames: telegramIntegration.usernames }}
          />
        )}
      </Row>
    </>
  );
};

const Row = styled.div<{ noMargin?: boolean; column?: boolean }>`
  display: flex;

  ${(p) => p.column && `flex-direction: column;`};

  ${(p) => !p.noMargin && `margin-bottom: 24px;`}

  :last-of-type {
    ${(p) => !p.noMargin && `margin-bottom: 12px;`}
  }

  .send-test-lead-button {
    align-self: flex-start;
  }
`;
